import React, { useEffect, useState } from 'react';
import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Stack,
  TextField,
} from '@mui/material';

import * as userApi from '../../lib/api/user';

const DOC_TYPE_OPTIONS = [
  { value: 'ORDER_BOOK', label: '수주품의서' },
  { value: 'HR_LEAVE', label: '휴가' },
];

const SCOPE_OPTIONS = [
  { value: 'FINAL', label: '전결(최종승인)' },
  { value: 'NOTIFIER', label: '결과 통보 대상' },
];

const emptyForm = {
  usrUuid: '',
  usrNm: '',
  docType: 'ORDER_BOOK',
  authScope: 'FINAL',
  minAmount: '',
  maxAmount: '',
};

// 전결 권한 생성/수정 다이얼로그. ksm_frontend ApprovalFinalAuthModal.js 포팅(2026-10-20) -
// bito는 조직/직위 기반 전결은 쓰지 않고 사용자 지정 + 금액 범위만 지원한다.
const ApprovalFinalAuthModal = ({ open, auth, onClose, onSave }) => {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState(emptyForm);

  useEffect(() => {
    userApi.getUsers().then((res) => setUsers(res?.data?.list || []));
  }, []);

  useEffect(() => {
    if (auth) {
      setForm({
        usrUuid: auth.usrUuid || '',
        usrNm: auth.usrNm || '',
        docType: auth.docType || 'ORDER_BOOK',
        authScope: auth.authScope || 'FINAL',
        minAmount: auth.minAmount ?? '',
        maxAmount: auth.maxAmount ?? '',
      });
    } else {
      setForm(emptyForm);
    }
  }, [auth, open]);

  const handleSave = () => {
    onSave({
      usrUuid: form.usrUuid,
      docType: form.docType,
      authScope: form.authScope,
      minAmount: form.minAmount === '' ? null : Number(form.minAmount),
      maxAmount: form.maxAmount === '' ? null : Number(form.maxAmount),
    });
  };

  const selectedUser = users.find((u) => u.usrUuid === form.usrUuid) || null;
  const canSave = form.usrUuid && form.docType && form.authScope;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{auth ? '전결 권한 수정' : '전결 권한 추가'}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Autocomplete
            options={users}
            getOptionLabel={(option) => option?.usrNm || ''}
            isOptionEqualToValue={(option, value) => option.usrUuid === value?.usrUuid}
            value={selectedUser}
            onChange={(e, value) =>
              setForm({ ...form, usrUuid: value ? value.usrUuid : '', usrNm: value ? value.usrNm : '' })
            }
            renderInput={(params) => <TextField {...params} label="대상 사용자" required />}
          />
          <TextField
            select
            label="대상 문서"
            value={form.docType}
            onChange={(e) => setForm({ ...form, docType: e.target.value })}
            fullWidth
          >
            {DOC_TYPE_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            label="구분"
            value={form.authScope}
            onChange={(e) => setForm({ ...form, authScope: e.target.value })}
            fullWidth
          >
            {SCOPE_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </TextField>
          {form.authScope === 'FINAL' && (
            <Stack direction="row" spacing={2}>
              <TextField
                type="number"
                label="최소 금액(선택)"
                value={form.minAmount}
                onChange={(e) => setForm({ ...form, minAmount: e.target.value })}
                fullWidth
              />
              <TextField
                type="number"
                label="최대 금액(선택)"
                value={form.maxAmount}
                onChange={(e) => setForm({ ...form, maxAmount: e.target.value })}
                fullWidth
              />
            </Stack>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          취소
        </Button>
        <Button onClick={handleSave} variant="contained" disabled={!canSave}>
          저장
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApprovalFinalAuthModal;
